/**
 * =============================================================================
 * IDS CRM Web - Web Vitals Reporting
 * =============================================================================
 *
 * PURPOSE:
 * Reports Core Web Vitals metrics for performance monitoring.
 * In production, these metrics should be sent to an analytics endpoint.
 *
 * METRICS:
 * - CLS (Cumulative Layout Shift): Visual stability
 * - FID (First Input Delay): Interactivity
 * - FCP (First Contentful Paint): Loading performance
 * - LCP (Largest Contentful Paint): Loading performance
 * - TTFB (Time to First Byte): Server response time
 *
 * =============================================================================
 */

/**
 * Reports web vitals to the provided callback function.
 *
 * @param {Function} onPerfEntry - Callback to receive performance entries
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
